export enum USER_ROLES {
    superAdmin = "super-admin",
    owner = "owner",
    admin = "admin",
    user = "user"
}

// Roles permitted to sign in to the abol-verify-admin platform. New accounts
// default to `user`, so only explicitly-promoted accounts get in.
export const ADMIN_ROLES: string[] = [USER_ROLES.superAdmin, USER_ROLES.admin];

export const isAdminRole = (role?: string | null): boolean =>
    role != null && ADMIN_ROLES.includes(role);

// Human-friendly labels for account roles.
export const ROLE_LABELS: Record<string, string> = {
    [USER_ROLES.superAdmin]: "Super Admin",
    [USER_ROLES.owner]: "Owner",
    [USER_ROLES.admin]: "Admin",
    [USER_ROLES.user]: "User",
};

export enum BANKS {
    cbe = "cbe",
    telebirr = "telebirr",
    boa = "boa"
}

export enum VERIFICATION_STATUS {
    pending = "pending",
    verified = "verified",
    rejected = "rejected",
    failed = "failed"
}

export enum PAYMENT_CURRENCY {
    ETB = "ETB",
    USD = "USD"
}

export enum PAYMENT_STATUS {
    pending = "pending",
    success = "success",
    failed = "failed",
    cancelled = "cancelled"
}

// Human-friendly labels for the banks supported by the verifier.
export const BANK_LABELS: Record<string, string> = {
    [BANKS.cbe]: "CBE",
    [BANKS.telebirr]: "telebirr",
    [BANKS.boa]: "Bank of Abyssinia",
};
